<div class="app-shell container-fluid px-0">
  <header class="app-header">
    <div class="container-fluid app-header__inner">
      <div class="row g-0 align-items-center">
        <div class="col-auto app-header__brand">
          <p-wordmark></p-wordmark>
        </div>
        <div class="col app-header__titles">
          <h1 class="app-title">Service Manager</h1>
        </div>
        <div class="col-auto app-header__nav">
          <p-tabs-bar [activeTabIndex]="activeTabIndex()">
            @for (item of navItems; track item.route) {
              <a [routerLink]="item.route">{{ item.label }}</a>
            }
          </p-tabs-bar>
        </div>
      </div>
    </div>
  </header>
  <hr class="border-width-base m-0" />
  <main class="container-fluid app-main px-3 px-md-4 py-4 py-md-5">
    <router-outlet></router-outlet>
  </main>
</div>
